import { httpClient } from 'api';
import { Program } from 'types/Program';
import {
	Survey,
	SurveyProgramQuestionBase,
	SurveyQuestionBase,
	SurveyQuestionBasTranslated,
	SurveyQuestionType,
} from 'types/Survey';

type UserTypeFilter = 'mentors' | 'mentees';

export type UpdateQuestionSettingsPayload = {
	inProgramStep?: number;
	inProgramSequence?: number;
	only?: boolean;
	// excluded?: boolean;
};

export type ModifyQuestionPayload = UpdateQuestionSettingsPayload &
	Pick<SurveyProgramQuestionBase, 'type' | 'text' | 'translations' | 'required' | 'forApplicationRole'> & {
		options: Array<
			Pick<SurveyQuestionBasTranslated, 'sequence' | 'text'> & {
				id?: number;
				translations?: Array<{ languageCode: string; text: string }>;
			}
		> | null;
	};

export const surveyApi = {
	getSurveyByUuid: (uuid: string) => httpClient.get<{ survey: Survey; program: Program }>(`survey/uuid/${uuid}`),
	getSurveyForProgramMembership: (programMembership: number) =>
		httpClient.get<Survey>(`survey/programMembership/${programMembership}`),
	updateSurveyByUuid: (uuid: string, data: { step: number; answers: Array<any> }) =>
		httpClient.put<Survey>(`survey/uuid/${uuid}`, data),
	updateSurveyForProgramMembership: (programMembership: number, data: { step: number; answers: Array<any> }) =>
		httpClient.put<Survey>(`survey/programMembership/${programMembership}`, data),
	checkSurveyPopupForProgramMembership: (programMembership: number) =>
		httpClient.get<boolean>(`survey/popup/${programMembership}`),
	panel: {
		getAllForProgram: (programId: number) =>
			httpClient.get<SurveyProgramQuestionBase[]>(`survey/admin/${programId}/all`),
		updateQuestionSettings: (programId: number, questionId: number, payload: UpdateQuestionSettingsPayload) =>
			httpClient.patch(`survey/admin/${programId}/question/${questionId}`, payload),
		addNewQuestion: (programId: number, payload: ModifyQuestionPayload) =>
			httpClient.post<SurveyQuestionBase>(`survey/admin/${programId}/question`, payload),
		updateQuestion: (programId: number, questionId: number, payload: ModifyQuestionPayload) =>
			httpClient.put<SurveyQuestionBase>(`survey/admin/${programId}/question/${questionId}`, payload),
		removeQuestion: (programId: number, questionId: number) =>
			httpClient.delete<'reactivated' | 'excluded' | 'deleted'>(
				`survey/admin/${programId}/question/${questionId}`
			),
		downloadFeedbackStatisticsXlsx: (programId: number) =>
			httpClient.get<Blob>(`/survey/admin/${programId}/xlsx`, undefined, { responseType: 'blob' }),
	},
};
